<template>
  <el-input :value="localVal" @input="onInput" @blur="onBlur" />
</template>

<script>
import ncformCommon from '@ncform/ncform-common';

export default {
  name: 'AutoIdWidget',
  mixins: [ncformCommon.mixins.vue.controlMixin],

  data() {
    return {
      localVal: '',
      editadoManualmente: false,
    };
  },

  computed: {
    autoVal() {
      const { campo1Key, campo2Key } = this.mergeConfig;
      if (!campo1Key || !campo2Key || !this.formData) return '';
      const v1 = this.formData[campo1Key];
      const v2 = this.formData[campo2Key];
      const ok = v => v !== null && v !== undefined && v !== '';
      return ok(v1) && ok(v2) ? `${v1}-${v2}` : '';
    },
  },

  watch: {
    modelVal: {
      handler(v) {
        const s = v != null ? String(v) : '';
        if (s !== this.localVal) {
          this.localVal = s;
        }
      },
      immediate: true,
    },
    autoVal(newVal, oldVal) {
      // When oldVal is empty and localVal already has a value, this is ncform
      // initializing formData in edit mode — not a real user change. Preserve existing id.
      if (!oldVal && this.localVal) return;
      if (!this.editadoManualmente) {
        this.localVal = newVal;
        this.modelVal = newVal;
      }
    },
  },

  methods: {
    onInput(v) {
      this.localVal = v;
      this.editadoManualmente = true;
      this.modelVal = v;
    },
    onBlur() {
      if (!this.localVal) {
        this.editadoManualmente = false;
        this.localVal = this.autoVal;
        this.modelVal = this.autoVal;
      }
    },
  },
};
</script>
